/**
 * Label Colors Utility
 * Provides consistent color schemes for label options across the application
 */

export interface LabelColorScheme {
  bg: string;
  border: string;
  color: string;
}

// Color palette for labels - designed to be visually distinct and accessible
export const LABEL_COLOR_PALETTE: LabelColorScheme[] = [
  { bg: '#fef7ff', border: '#d8b4fe', color: '#9333ea' }, // Purple
  { bg: '#f0f9ff', border: '#bfdbfe', color: '#2563eb' }, // Blue
  { bg: '#f0fdf4', border: '#86efac', color: '#16a34a' }, // Green
  { bg: '#fefce8', border: '#fde047', color: '#ca8a04' }, // Yellow
  { bg: '#fef2f2', border: '#fca5a5', color: '#dc2626' }, // Red
  { bg: '#f5f3ff', border: '#c4b5fd', color: '#7c3aed' }, // Indigo
  { bg: '#fff7ed', border: '#fed7aa', color: '#ea580c' }, // Orange
  { bg: '#ecfdf5', border: '#6ee7b7', color: '#059669' }, // Emerald
];

/**
 * Get consistent color scheme for a label option
 * @param optionText The text of the label option
 * @param allOptions Array of all label options to maintain consistent indexing
 * @returns Color scheme object with bg, border, and color properties
 */
export const getLabelColorScheme = (optionText: string, allOptions: string[]): LabelColorScheme => {
  const index = allOptions.indexOf(optionText);
  return index >= 0 ? LABEL_COLOR_PALETTE[index % LABEL_COLOR_PALETTE.length] : LABEL_COLOR_PALETTE[0];
};

/**
 * Get color scheme by index (useful when you just want to cycle through colors)
 * @param index The index of the color to get
 * @returns Color scheme object
 */
export const getLabelColorSchemeByIndex = (index: number): LabelColorScheme => {
  return LABEL_COLOR_PALETTE[index % LABEL_COLOR_PALETTE.length];
};
